import React from 'react';

const MortgageLoanAmountFilterIcon = (props: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_1426_6159)">
      <path
        d="M4.66665 14.9999L2.99998 13.3333L1.33331 14.9999"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66667 18.6666H4.33333C3.97971 18.6666 3.64057 18.5261 3.39052 18.2761C3.14048 18.026 3 17.6869 3 17.3333V13.3333"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <g clipPath="url(#clip1_1426_6159)">
      <path d="M15.3333 5L17 6.66667L18.6666 5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M13.3333 1.33325H15.6666C16.0203 1.33325 16.3594 1.47373 16.6095 1.72378C16.8595 1.97382 17 2.31296 17 2.66659V6.66658"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <g clipPath="url(#clip2_1426_6159)">
      <path
        d="M15 19.1666C17.3012 19.1666 19.1666 17.3011 19.1666 14.9999C19.1666 12.6987 17.3012 10.8333 15 10.8333C12.6988 10.8333 10.8333 12.6987 10.8333 14.9999C10.8333 17.3011 12.6988 19.1666 15 19.1666Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M15 16.5V17" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M15 13L15 13.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M15.9091 13.7273H14.5454C14.3767 13.7273 14.2148 13.7943 14.0954 13.9137C13.9761 14.033 13.9091 14.1949 13.9091 14.3637C13.9091 14.5324 13.9761 14.6943 14.0954 14.8136C14.2148 14.933 14.3767 15 14.5454 15H15.4545C15.6233 15 15.7852 15.0671 15.9045 15.1864C16.0239 15.3058 16.0909 15.4676 16.0909 15.6364C16.0909 15.8052 16.0239 15.967 15.9045 16.0864C15.7852 16.2057 15.6233 16.2728 15.4545 16.2728H13.9091"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <g clipPath="url(#clip3_1426_6159)">
      <path
        d="M1.25 3.74992L5 0.833252L8.75 3.74992V8.33325C8.75 8.55427 8.6622 8.76623 8.50592 8.92251C8.34964 9.07879 8.13768 9.16659 7.91667 9.16659H2.08333C1.86232 9.16659 1.65036 9.07879 1.49408 8.92251C1.3378 8.76623 1.25 8.55427 1.25 8.33325V3.74992Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M3.75 9.16667V5H6.25V9.16667" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_1426_6159">
        <rect width="8" height="8" fill="white" transform="translate(0 12)" />
      </clipPath>
      <clipPath id="clip1_1426_6159">
        <rect width="8" height="8" fill="white" transform="translate(12)" />
      </clipPath>
      <clipPath id="clip2_1426_6159">
        <rect width="10" height="10" fill="white" transform="translate(10 10)" />
      </clipPath>
      <clipPath id="clip3_1426_6159">
        <rect width="10" height="10" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default MortgageLoanAmountFilterIcon;
